import { create } from 'zustand';

const routerStatusStore = create((set) => ({
  ContentNode: null,
  ActiveConfig: null,
  ContentNodeList: [],
  update: (val) => set({ ContentNode: val }),
  updateContentNodeList: (val) => set({ ContentNodeList: val }),
  updateActiveConfig: (val) => set({ ActiveConfig: val }),
}));

export const useRouterStatus = () =>
  routerStatusStore((state) => [
    {
      ContentNode: state.ContentNode,
      ContentNodeList: state.ContentNodeList,
      ActiveConfig: state.ActiveConfig,
    },
    state.update,
    state.updateContentNodeList,
    state.updateActiveConfig,
  ]);
